import React from "react";
import LoginForm from "../../components/auth-forms/login-form/LoginForm";

export default function LoginPage() {
  return (
    <div>
      <LoginForm />
    </div>
  );
}
